import type {
  TAssinaturaContratoEnum,
  TFormaPagamentoComissaoEnum,
  TOpcaoVagaEnum,
  TTipoAssinaturaEnum,
  TTipoDoCompradorEnum,
  TTipoDoVinculoDoCompradorEnum,
  TTipoEmolumentoEnum,
} from '@/features/proposta/interfaces/proposta.enums'
import type { TStatusProposta } from '@/shared/interfaces/proposta.enums'

export type TGetVendedoresUnidadeNegocioResponse = Array<{
  id: string
  nome: string
  idExterno: number
  email: string
  possuiDadosDeComissao: boolean
}>

export type TPropostaLocationState = {
  simulacoesIds: string[]
}

export type TGetCorretagensResponse = Array<{
  idExterno: string
  percentualCorretagem: number | null
  valorCorretagem: number | null
}>

type TImobiliariaCorretor = {
  descricao: string
  idExterno: string
  documento: string
  tipoImobiliariaCorretor: 'Imobiliaria' | 'CorretorAutonomo'
  nome: string
}
export type TParticipacaoImobiliariaCorretor =
  | {
      imobiliariaCorretor: TImobiliariaCorretor
      corretagem: { tipo: 'percentual'; percentualCorretagemImobiliaria: number }
    }
  | { imobiliariaCorretor: TImobiliariaCorretor; corretagem: { tipo: 'valor'; valorCorretagemImobiliaria: number } }

export type TParticipacaoData =
  | {
      imobiliariaCorretorIdExterno: string
      percentualCorretagemImobiliaria: number
      formaPagamentoComissao: TFormaPagamentoComissaoEnum
    }
  | {
      imobiliariaCorretorIdExterno: string
      valorCorretagemImobiliaria: number
      formaPagamentoComissao: TFormaPagamentoComissaoEnum
    }

export type TPropostaData = {
  clienteAtendimentoId: string
  vendedorId: string
  compradores: Array<{
    pessoaId: string
    percentualParticipacao: number
    tipoCliente: TTipoDoCompradorEnum
    vinculos: Array<{
      clienteId: string
      tipo: TTipoDoVinculoDoCompradorEnum
      procuradoresIds: string[]
    }>
    procuradoresIds: string[]
    tipoAssinatura: TTipoAssinaturaEnum | null
  }>
  participacoes: TParticipacaoData[]
  assinaturaContrato: TAssinaturaContratoEnum
  observacoes?: string | null
  termosDaProposta?: string | null
  idExternoBloco: number
  opcaoDeVaga: TOpcaoVagaEnum
  idsExternosVagasPadrao: number[]
  plantaId: string | null
  simulacoes: Array<{ id: string; idExternoProduto: number; substituiVagaPadrao: boolean }>
  compradorTitularId: string
  tipoEmolumento: TTipoEmolumentoEnum | null
}

export type TCriarPropostaResponse = {
  id: string
  message: string
  date: string
  data: TPropostaData & { numero: number }
}

export type TGetPropostaResponse = {
  id: string
  numero: number
  data: string
  status: TStatusProposta
  titular: string
  nomeEmpreendimento: string
  nomeBloco: string
  unidade?: string
  lote?: string
  tipoDeEmpreendimento: 'Horizontal' | 'Vertical'
  descricaoPlanta?: string
  dataMarcacaoAlvenaria?: string
  acessorio?: string
  vagasPadrao?: string
  valorTotalProposta: number
  todosDocumentosEnviados: boolean
}

export const PapelCompradorPF = {
  COMPRADOR: 'Comprador',
  CONJUGE: 'Conjuge',
  MAE_PAI: 'MaePai',
  REPRESENTANTE: 'Representante',
  PROCURADOR: 'Procurador',
} as const

export type TPapelComprador = (typeof PapelCompradorPF)[keyof typeof PapelCompradorPF]

export type TPapelCompradorPF = Pick<typeof PapelCompradorPF, 'COMPRADOR' | 'CONJUGE' | 'MAE_PAI'>[keyof Pick<
  typeof PapelCompradorPF,
  'COMPRADOR' | 'CONJUGE' | 'MAE_PAI'
>]

type TCompradoresCadastradosVinculo = {
  nome: string
  maiorDe18Anos: boolean
  documento: string
  tipo: 'Representante' | 'MaePai' | 'Conjuge'
  id: string
}

export type TCompradoresCadastrados = Array<{
  documento: string
  id: string
  maiorDe18Anos: boolean | null
  nome: string
  tipo: 'PessoaFisica' | 'PessoaJuridica'
  vinculos: TCompradoresCadastradosVinculo[]
}>

export type TPessoaDocumento = {
  pessoaId: string
  nome: string
  tipoComprador: string
  documento: string
  quantidadeDocumentosAnexados: number
}

export type TGetListaCompradoresDocumentosResponse = TPessoaDocumento[]
